module.exports = __webpack_public_path__ + "static/img/gun-num.1c0ed3f3.png";